import { useQuery } from '@tanstack/vue-query';
import { api } from '@/hooks/axios-api';


const fetchHealthInsurances = async () => {
  const response = await api.get('/tools/funders/');
  return response.data;
}

const fetchMedicalSchemeHealthSeekers = async (schemeId: string, programmePhases: string) => {
  //TODO: move status=enrolled to be calculated on server side
  const programme_phases = programmePhases ? programmePhases : "so,si,ro,ri";
  const params = schemeId ? { scheme_id: schemeId, status:"enrolled", programme_phases: programme_phases } : {};
  const response = await api.get('/tools/scheme-health-seekers', {params});
  return response.data;
}


///////////////////// HOOKS //////////////////////////// 


export const usefetchHealthInsurances = () => useQuery({
    queryKey: ["healthInsurances"],
    queryFn: () => fetchHealthInsurances(),
    // refetchInterval: 3000
    refetchOnWindowFocus: true,
});

export const useFetchMedicalSchemeHealthSeekers = (schemeId: string, benefitTypes: string) => useQuery({
  queryKey: ["medicalSchemeHealthSeekers", schemeId, benefitTypes],
  queryFn: () => fetchMedicalSchemeHealthSeekers(schemeId, benefitTypes),
  // refetchInterval: 3000
  refetchOnWindowFocus: true,
});